/**
 * A escada de raridade, do banco para a tela.
 *
 * **O banco fala inglês** (`rods.rarity` é um enum `common … mythic`) e o cliente fala português:
 * é em português que estão as classes do aro do `FishSlot` (`.fish-slot--rara`) e as chaves de
 * `rarity.*` no i18n. Sem a tradução no meio, dois defeitos aparecem juntos — foi o que a Marina
 * mostrava em 09/09/2026:
 *
 * - o aro do encaixe caía no cinza de comum para tudo, porque `.fish-slot--rare` não existe;
 * - o rótulo saía cru na tela: **"rarity.epic"**, porque a chave em inglês não existe no i18n.
 *
 * O mapa já existia copiado em três telas (`Apetrechos`, `DailyFishingModal`, `FishMarketModal`),
 * cada uma com a sua cópia. Esta é a versão única; as três continuam com a delas até alguém
 * passar por lá — o que não pode é a quarta cópia nascer.
 *
 * ## O gênero
 *
 * "Vara rara", "barco raro". O português não deixa escolher um só, e o i18n tem os dois — daí o
 * segundo parâmetro. O padrão é o **feminino**, que é o que as três cópias já usavam.
 */

const FEMININO = {
  common: 'comum',
  uncommon: 'incomum',
  rare: 'rara',
  epic: 'epica',
  legendary: 'lendaria',
  mythic: 'mitica',
};

const MASCULINO = {
  common: 'comum',
  uncommon: 'incomum',
  rare: 'raro',
  epic: 'epico',
  legendary: 'lendario',
  mythic: 'mitico',
};

/** O gênero de cada prateleira da loja. Sem entrada, vale o feminino. */
export const GENERO_DA_CATEGORIA = {
  rod: 'f', // vara
  bait: 'f', // isca
  boat: 'm', // barco
  house: 'f', // casa
  map: 'm', // mapa
};

/**
 * `'epic'` → `'epica'`. Valor já em português passa direto — as telas de exploração e o
 * inventário guardam a escada em português desde antes, e traduzir de novo quebraria as duas.
 *
 * @param {string} valor a raridade, em inglês ou já em português
 * @param {'f'|'m'} genero a concordância desejada; padrão feminino
 */
export function raridadePt(valor, genero = 'f') {
  const cru = String(valor || '').toLowerCase();
  if (!cru) return 'comum';
  const tabela = genero === 'm' ? MASCULINO : FEMININO;
  return tabela[cru] || cru;
}
